import React from 'react'
import styles from './SectionContainer.module.scss'

export type StyledSectionContainerProps = {
  className?: string
  children: React.ReactNode
}

export const StyledSectionContainer: React.FC<StyledSectionContainerProps> = ({ className, children }) => {
  return (
    <div className={`flex flex-col items-center w-full ${styles.container} ${className}`}>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  )
}
